import EventBus from "../eventbus/EventBus";

import { AMPLITUDE_EVENTS } from "./AmplitudeEvents";

export const dispatchAmplitude = ({
    eventType,
    selection,
    payload
}: {
    eventType: (typeof AMPLITUDE_EVENTS)[keyof typeof AMPLITUDE_EVENTS];
    payload?: { [key: string]: any };
    selection: string;
}) => {
    if (!eventType) {
        throw new Error("eventType is required");
    }

    if (!selection) {
        throw new Error("selection is required");
    }

    const eventBus = new EventBus(window, document);

    return eventBus.dispatchAmplitude({
        event_type: eventType,
        event_properties: {
            selection,
            ...payload
        }
    });
};
